import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

const IDLE_MINUTES = 29; // Time in minutes before showing the warning popup
const COUNTDOWN_SECONDS = 60;
const CIRCLE_RADIUS = 68;
const CIRCUMFERENCE = 2 * Math.PI * CIRCLE_RADIUS;

@Component({
  selector: 'app-idle-timeout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './idle-timeout.component.html',
})
export class IdleTimeoutComponent implements OnInit, OnDestroy {
  show_popup = false;
  seconds_left = COUNTDOWN_SECONDS;
  circumference = CIRCUMFERENCE;

  private idle_timer: any = null;
  private countdown_timer: any = null;
  private resume_delay_timer: any = null;
  private move_events = ['mousemove', 'keydown', 'touchstart', 'scroll'];
  private click_events = ['click', 'mousedown'];

  constructor(private router: Router, private zone: NgZone) { }

  ngOnInit() {
    this.move_events.forEach(event =>
      document.addEventListener(event, this.on_activity, { passive: true })
    );
    this.click_events.forEach(event =>
      document.addEventListener(event, this.on_click, { passive: true })
    );
    this.reset_idle_timer();
  }

  on_activity = () => {
    if (this.show_popup) {
      clearTimeout(this.resume_delay_timer);
      this.resume_delay_timer = setTimeout(() => {
        this.zone.run(() => this.resume());
      }, 1000);
      return;
    }
    this.reset_idle_timer();
  };

  on_click = () => {
    if (this.show_popup) {
      this.zone.run(() => this.resume());
      return;
    }
    this.reset_idle_timer();
  };

  reset_idle_timer() {
    clearTimeout(this.idle_timer);
    this.idle_timer = setTimeout(() => {
      this.zone.run(() => this.show_warning());
    }, IDLE_MINUTES * 60 * 1000);
  }

  show_warning() {
    this.show_popup = true;
    this.seconds_left = COUNTDOWN_SECONDS;
    this.start_countdown();
  }

  start_countdown() {
    clearInterval(this.countdown_timer);
    this.countdown_timer = setInterval(() => {
      this.seconds_left--;
      if (this.seconds_left <= 0) {
        clearInterval(this.countdown_timer);
        this.force_logout();
      }
    }, 1000);
  }

  resume() {
    this.show_popup = false;
    clearInterval(this.countdown_timer);
    this.reset_idle_timer();
  }

  force_logout() {
    this.show_popup = false;
    localStorage.clear();
    this.router.navigate(['/sign-in']);
  }

  get stroke_dashoffset(): number {
    return CIRCUMFERENCE * (1 - this.seconds_left / COUNTDOWN_SECONDS);
  }

  get display_minutes(): string {
    return String(Math.floor(this.seconds_left / 60)).padStart(2, '0');
  }

  get display_seconds(): string {
    return String(this.seconds_left % 60).padStart(2, '0');
  }

  ngOnDestroy() {
    this.move_events.forEach(event =>
      document.removeEventListener(event, this.on_activity));
    this.click_events.forEach(event =>
      document.removeEventListener(event, this.on_click)
    );
    clearTimeout(this.idle_timer);
    clearTimeout(this.resume_delay_timer);
    clearInterval(this.countdown_timer);
  }
}
